(function () {
	var Nav = function (element) {
		this.element = element;
		this.innerElement = this.element.getElementsByClassName('js-nav__inner');
		this.trigger = document.querySelector('[aria-controls="' + this.element.getAttribute('id') + '"]');
		this.animationDuration = parseFloat(getComputedStyle(this.element).getPropertyValue('--nav-transition-duration')) || 0.3;
		// store some basic classes
		this.navIsVisibleClass = 'nav--is-visible';
		this.navLevelClass = 'js-nav__list';
		this.navBtnInClass = 'js-nav__btn--sublist-control';
		this.navBtnOutClass = 'js-nav__btn--back';
		this.levelInClass = 'nav__list--in';
		this.levelOutClass = 'nav__list--out';
		// store the max height of the element
		this.maxHeight = false;
		// store drop nav layout
		this.layout = false;
		// vertical gap - desktop layout
		this.verticalGap = parseInt(getComputedStyle(this.element).getPropertyValue('--nav-gap-y')) || 4;
		// focusable elements
		this.focusableElements = [];
		initNav(this);
	};

	function initNav(nav) {
		// trigger drop nav opening/closing
		toggleNav(nav);
		// toggle sublevels
		nav.element.addEventListener('click', function (event) {
			// check if we need to show a new sublevel
			var navBtnIn = event.target.closest('.' + nav.navBtnInClass);
			if (navBtnIn) showSubLevel(nav, navBtnIn);
			// check if we need to go back to a previous level
			var navBtnOut = event.target.closest('.' + nav.navBtnOutClass);
			if (navBtnOut) hideSubLevel(nav, navBtnOut);
		});
		// close drop nav on focus out
		initFocusOut(nav);
	};

	function toggleNav(nav) { // toggle drop nav
		if (!nav.trigger) return;
		// actions to be performed when closing the drop nav
		nav.dropMenuClosed = function (event) {
			if (event.propertyName != 'visibility') return;
			if (getComputedStyle(nav.element).getPropertyValue('visibility') != 'hidden') return;
			nav.element.removeEventListener('transitionend', nav.dropMenuClosed);
			nav.element.removeAttribute('style');
			resetAllLevels(nav); // go back to main list
		};

		// on mobile - close drop nav when clicking on close btn
		nav.element.addEventListener('click', function (event) {
			var target = event.target.closest('.js-nav__close-btn');
			if (!target || !dropMenuVisible(nav)) return;
			nav.trigger.click();
		});

		// click on trigger
		nav.trigger.addEventListener('click', function (event) {
			nav.element.removeEventListener('transitionend', nav.dropMenuClosed);
			var isVisible = dropMenuVisible(nav);
			nav.element.classList.toggle(nav.navIsVisibleClass, !isVisible);
			isVisible ? nav.trigger.removeAttribute('aria-expanded') : nav.trigger.setAttribute('aria-expanded', true);
			if (isVisible) {
				nav.element.addEventListener('transitionend', nav.dropMenuClosed);
			} else {
				nav.element.addEventListener('transitionend', function cb() {
					nav.element.removeEventListener('transitionend', cb);
					focusFirstElement(nav, nav.element);
				});
				getLayoutValue(nav);
				setNavMaxHeight(nav); // set max-height
				placeNav(nav); // desktop only
			}
		});
	};

	function dropMenuVisible(nav) {
		return nav.element.classList.contains(nav.navIsVisibleClass);
	};

	function showSubLevel(nav, navBtn) {
		var mainLevel = navBtn.closest('.' + nav.navLevelClass),
			subLevel = getChildrenByClassName(navBtn.parentNode, nav.navLevelClass);
		if (!mainLevel || subLevel.length == 0) return;
		// trigger classes
		subLevel[0].classList.add(nav.levelInClass);
		mainLevel.classList.add(nav.levelOutClass);
		mainLevel.classList.remove(nav.levelInClass);

		let footerMenu = document.querySelector('.nav__footer');
		footerMenu.classList.add('hidden');

		// animate height of main element
		animateNav(nav, mainLevel.offsetHeight, subLevel[0].offsetHeight, function () {
			focusFirstElement(nav, subLevel[0]);
		});
	};

	function hideSubLevel(nav, navBtn) {
		var subLevel = navBtn.closest('.' + nav.navLevelClass),
			mainLevel = subLevel.parentNode.closest('.' + nav.navLevelClass);
		if (!mainLevel || !subLevel) return;
		// trigger classes
		subLevel.classList.remove(nav.levelInClass);
		mainLevel.classList.add(nav.levelInClass);
		mainLevel.classList.remove(nav.levelOutClass);

		let footerMenu = document.querySelector('.nav__footer');
		footerMenu.classList.remove('hidden');

		// animate height of main element
		animateNav(nav, subLevel.offsetHeight, mainLevel.offsetHeight, function () {
			var navBtnIn = getChildrenByClassName(subLevel.parentNode, nav.navBtnInClass);
			if (navBtnIn.length > 0) navBtnIn[0].focus();
			// if primary level -> reset height of element + inner element
			if (mainLevel.classList.contains('js-nav__list--main') && nav.layout == 'desktop') {
				nav.element.style.height = '';
				if (nav.innerElement.length > 0) nav.innerElement[0].style.height = '';
			}
		});
	};

	function animateNav(nav, initHeight, finalHeight, cb) {
		if (nav.innerElement.length < 1) {
			if (cb) setTimeout(function () { cb(); }, nav.animationDuration * 1000);
			return;
		}
		if (nav.layout == 'mobile') {
			nav.innerElement[0].style.height = finalHeight + "px";
			if (cb) setTimeout(function () { cb(); }, nav.animationDuration * 1000);
			return;
		} else {
			nav.innerElement[0].style.height = "";
		}
		var resetHeight = false;
		// make sure init and final height are smaller than max height
		if (initHeight > nav.maxHeight) initHeight = nav.maxHeight;
		if (finalHeight > nav.maxHeight) {
			resetHeight = finalHeight;
			finalHeight = nav.maxHeight;
		}
		var change = finalHeight - initHeight,
			currentTime = null,
			duration = nav.animationDuration * 1000;

		var animateHeight = function (timestamp) {
			if (!currentTime) currentTime = timestamp;
			var progress = timestamp - currentTime;
			if (progress > duration) progress = duration;
			var val = Math.easeOutQuart(progress, initHeight, change, duration);
			nav.element.style.height = val + "px";
			if (progress < duration) {
				window.requestAnimationFrame(animateHeight);
			} else {
				nav.innerElement[0].style.height = resetHeight ? resetHeight + 'px' : '';
				if (cb) cb();
			}
		};

		//set the height of the element before starting animation -> fix bug on Safari
		nav.element.style.height = initHeight + "px";
		window.requestAnimationFrame(animateHeight);
	};

	function resetAllLevels(nav) {
		var openLevels = nav.element.getElementsByClassName(nav.levelInClass),
			closeLevels = nav.element.getElementsByClassName(nav.levelOutClass);
		while (openLevels[0]) {
			openLevels[0].classList.remove(nav.levelInClass);
		}
		while (closeLevels[0]) {
			closeLevels[0].classList.remove(nav.levelOutClass);
		}
	};

	function focusFirstElement(nav, level) {
		var element = getFirstFocusable(level);
		element.focus();
	};

	function getFirstFocusable(element) {
		var elements = element.querySelectorAll(focusableElString);
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
				return elements[i];
			}
		}
	};

	function getFocusableElements(nav) { // all visible focusable elements
		var elements = nav.element.querySelectorAll(focusableElString);
		nav.focusableElements = [];
		for (var i = 0; i < elements.length; i++) {
			if (isVisible(nav, elements[i])) nav.focusableElements.push(elements[i]);
		}
	};

	function isVisible(nav, element) {
		var elementVisible = false;
		if ((element.offsetWidth || element.offsetHeight || element.getClientRects().length) && getComputedStyle(element).getPropertyValue('visibility') == 'visible') {
			elementVisible = true;
			if (nav.element.contains(element) && element.parentNode) elementVisible = isVisible(nav, element.parentNode);
		}
		return elementVisible;
	};

	function setNavMaxHeight(nav) {
		if (!nav.trigger) return;
		if (nav.layout == 'mobile') {
			nav.maxHeight = '100%';
			nav.element.style.maxHeight = nav.maxHeight;
		} else {
			nav.maxHeight = window.innerHeight - nav.trigger.getBoundingClientRect().bottom - nav.verticalGap - 15;
			nav.element.style.maxHeight = nav.maxHeight + 'px';
		}
	};

	function getLayoutValue(nav) {
		nav.layout = getComputedStyle(nav.element, ':before').getPropertyValue('content').replace(/\'|"/g, '');
	};

	function placeNav(nav) {
		if (nav.layout == 'mobile') {
			nav.element.style.top = nav.element.style.left = nav.element.style.right = '';
		} else {
			var selectedTriggerPosition = nav.trigger.getBoundingClientRect();

			var left = selectedTriggerPosition.left,
				right = (window.innerWidth - selectedTriggerPosition.right),
				isRight = (window.innerWidth < selectedTriggerPosition.left + nav.element.offsetWidth);

			var rightVal = 'auto', leftVal = 'auto';
			if (isRight) {
				rightVal = right + 'px';
			} else {
				leftVal = left + 'px';
			}

			var topVal = (selectedTriggerPosition.bottom + nav.verticalGap) + 'px';
			if (isRight && (right + nav.element.offsetWidth) > window.innerWidth) {
				rightVal = 'auto';
				leftVal = parseInt((window.innerWidth - nav.element.offsetWidth) / 2) + 'px';
			}
			nav.element.style.top = topVal;
			nav.element.style.left = leftVal;
			nav.element.style.right = rightVal;
		}
	};

	function closeOnResize(nav) {
		getLayoutValue(nav);
		if (nav.layout == 'mobile' || !dropMenuVisible(nav)) return;
		nav.trigger.click();
	};

	function closeOnClick(nav, target) {
		if (nav.layout == 'mobile' || !dropMenuVisible(nav)) return;
		if (nav.element.contains(target) || nav.trigger.contains(target)) return;
		nav.trigger.click();
	};

	function initFocusOut(nav) {
		nav.element.addEventListener('keydown', function (event) {
			if (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab') {
				getFocusableElements(nav);
				if ((nav.focusableElements[0] == document.activeElement && event.shiftKey) || (nav.focusableElements[nav.focusableElements.length - 1] == document.activeElement && !event.shiftKey)) {
					nav.trigger.click();
				}
			} else if (event.keyCode && event.keyCode == 27 || event.key && event.key.toLowerCase() == 'escape' && dropMenuVisible(nav)) {
				nav.trigger.click();
			}
		});
	};

	function getChildrenByClassName(el, className) {
		var children = el.children,
			childrenByClass = [];
		for (var i = 0; i < children.length; i++) {
			if (children[i].classList.contains(className)) childrenByClass.push(children[i]);
		}
		return childrenByClass;
	};

	Math.easeOutQuart = function (t, b, c, d) {
		t /= d;
		t--;
		return -c * (t * t * t * t - 1) + b;
	};

	// init Nav objects
	var dropMenus = document.getElementsByClassName('js-nav');
	var focusableElString = '[href], input:not([disabled]), select:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable], summary';
	if (dropMenus.length > 0) {
		var dropMenusArray = [];
		for (var i = 0; i < dropMenus.length; i++) {
			(function (i) {
				dropMenusArray.push(new Nav(dropMenus[i]));
			})(i);
		}

		// on resize -> close all drop nav elements
		window.addEventListener('resize', function (event) {
			dropMenusArray.forEach(function (element) {
				closeOnResize(element);
			});
		});

		// close drop nav when clicking outside it
		window.addEventListener('click', function (event) {
			dropMenusArray.forEach(function (element) {
				closeOnClick(element, event.target);
			});
		});
	}
}());

// File#: _1_anim-nav-btn
// Usage: codyhouse.co/license
(function () {
	var navBtns = document.getElementsByClassName('js-anim-nav-btn');
	if (navBtns.length > 0) {
		for (var i = 0; i < navBtns.length; i++) {
			(function (i) {
				initMenuBtn(navBtns[i]);
			})(i);
		}

		function initMenuBtn(btn) {
			btn.addEventListener('click', function (event) {
				event.preventDefault();
				var status = !btn.classList.contains('anim-nav-btn--state-b');
				btn.classList.toggle('anim-nav-btn--state-b', status);
				// emit custom event
				var event = new CustomEvent('anim-nav-btn-clicked', { detail: status });
				btn.dispatchEvent(event);
			});
		};
	}
}());
